import ExtendableError from './ExtendableError';
export default class ValueError extends ExtendableError {

}